export const zuiBlue = {
  100: '#D0E2F6',
  200: '#A5C7EE',
  300: '#79ACE6',
  400: '#4E92DF',
  500: '#2777D3',
  600: '#1F5EA8',
  700: '#17477D',
};
